module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-568.af57b024.jpg";